/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Render only the cart count, keeping header menus and event listeners intact.
  const cartBadgeSectionId = 'api-cart-count';
  let cartBadgeVersion = 0;
  let cartBadgeRefreshPending = false;
  let cartBadgeRequestedCount = null;

  function refreshCartBadge(event) {
    const cart = event && event.detail && event.detail.cart;
    const count = cart && (cart.item_count ?? (cart.cart && cart.cart.item_count));

    // Rebuy may report the same cart more than once. Use its count only to
    // avoid redundant renders; the displayed value still comes from Liquid.
    if (Number.isInteger(count) && count >= 0) {
      if (cartBadgeRefreshPending && count === cartBadgeRequestedCount) return;

      const badges = document.querySelectorAll('[data-section-type="header"] [data-cart-count]');
      if (!cartBadgeRefreshPending && badges.length && Array.from(badges).every((badge) => badge.getAttribute('data-cart-count') === String(count))) {
        return;
      }
      cartBadgeRequestedCount = count;
    } else {
      cartBadgeRequestedCount = null;
    }

    cartBadgeVersion += 1;
    if (!cartBadgeRefreshPending) renderCartBadge();
  }

  async function renderCartBadge() {
    const header = document.querySelector('[data-section-type="header"]');
    if (!header) return;

    const version = cartBadgeVersion;
    cartBadgeRefreshPending = true;

    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', cartBadgeSectionId);

      const response = await fetch(url.toString(), { cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to render the cart badge');

      const sections = await response.json();
      if (typeof sections[cartBadgeSectionId] !== 'string') {
        throw new Error('Cart count section was not rendered');
      }

      const rendered = new DOMParser().parseFromString(sections[cartBadgeSectionId], 'text/html');
      const badge = rendered.querySelector('[data-cart-count]');
      if (!badge) throw new Error('Rendered section has no cart count');

      // A newer cart change needs its own render; never apply an older result.
      if (version !== cartBadgeVersion) return;

      const count = badge.getAttribute('data-cart-count');
      if (!/^\d+$/.test(count)) throw new Error('Rendered cart count is invalid');
      document.querySelectorAll('[data-section-type="header"] [data-cart-count]').forEach((current) => {
        current.textContent = badge.textContent;
        current.setAttribute('data-cart-count', count);
      });
    } catch (error) {
      if (version === cartBadgeVersion) cartBadgeRequestedCount = null;
      console.warn('Cart badge refresh failed:', error);
    } finally {
      cartBadgeRefreshPending = false;
      if (version !== cartBadgeVersion) renderCartBadge();
    }
  }

  ['rebuy:cart.ready', 'rebuy:cart.change', 'theme:cart:change', 'cart:updated'].forEach((eventName) => {
    document.addEventListener(eventName, refreshCartBadge);
  });

  // The initial page already has its Liquid count. Revalidate restored pages
  // because browser back/forward caching can bring back an old badge.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCartBadge();
  });

  // Search Results Enhancement - Show best sellers when no results found
  function enhanceSearchResults() {
    const searchInput = document.querySelector('[data-predictive-search-input="search-popdown-results"]');
    const productWrapper = document.querySelector('[data-product-wrap]');
    const bestsellersSection = document.querySelector('[data-bestsellers-wrap]');
    const searchResultsContainer = document.querySelector('#search-popdown-results');
    
    if (!searchInput || !productWrapper || !bestsellersSection) {
      return; // Elements not found, skip enhancement
    }

    let searchPerformed = false;
    let lastSearchTerm = '';

    // Function to check if we should show best sellers
    function checkShowBestsellers() {
      const searchTerm = searchInput.value.trim();
      const hasProducts = productWrapper.children.length > 0 && 
                        productWrapper.textContent.trim() !== '';
      const searchResultsVisible = searchResultsContainer.querySelector('.search__results__outer').offsetParent !== null;
      
      // Only show best sellers if:
      // 1. A search was performed (not just empty state)
      // 2. There's a search term
      // 3. No products were found
      // 4. Search results container is visible (search dropdown is open)
      if (searchPerformed && searchTerm.length > 1 && !hasProducts && searchResultsVisible) {
        bestsellersSection.style.display = 'block';
      } else {
        bestsellersSection.style.display = 'none';
      }
    }

    // Monitor search input to track when searches are performed
    searchInput.addEventListener('input', function() {
      const currentSearchTerm = searchInput.value.trim();
      
      // Reset search state if input is cleared
      if (currentSearchTerm.length <= 1) {
        searchPerformed = false;
        bestsellersSection.style.display = 'none';
      } else if (currentSearchTerm !== lastSearchTerm && currentSearchTerm.length > 1) {
        // A new search is being performed
        searchPerformed = true;
        lastSearchTerm = currentSearchTerm;
        
        // Wait for the search API to respond
        setTimeout(checkShowBestsellers, 1200);
      }
    });

    // Create a MutationObserver to watch for changes in the product wrapper
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && searchPerformed) {
          // Delay check to ensure DOM is fully updated
          setTimeout(checkShowBestsellers, 100);
        }
      });
    });

    // Start observing changes to the product wrapper
    observer.observe(productWrapper, {
      childList: true,
      subtree: true
    });

    // Hide best sellers when search popdown is closed
    document.addEventListener('click', function(e) {
      if (!searchResultsContainer.contains(e.target) && !searchInput.contains(e.target)) {
        searchPerformed = false;
        bestsellersSection.style.display = 'none';
      }
    });
  }

  // Initialize search enhancement when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSearchResults);
  } else {
    enhanceSearchResults();
  }

  const shoppableWrapper = document.querySelectorAll(
    ".shoppable-img__product-overlay"
  );
  const shoppableDots = document.querySelectorAll("[data-shoppable-click]");
  const shoppablePopup = document.querySelectorAll("[data-shoppable-popup]");

  shoppableWrapper.forEach((wrapper) => {
    wrapper.onclick = (e) => {
      const shoppableId = e.target.dataset.id;
      if (shoppableId) {
        shoppableDots.forEach((dot) => {
          dot.classList.remove("active");
        });
      }
      e.target.classList.add("active");
      shoppablePopup.forEach((popup) => {
        popup.classList.remove("active");
      });
      const popupElement = document.getElementById(shoppableId);
      popupElement.classList.add("active");
    };
  });

  const addLoadingState = (button) => {
    if (!button.classList.contains("is-loading")) {
      button.classList.add("is-loading");
    }
  };

  const removeLoadingState = (button) => {
    button.classList.remove("is-loading");
  };

  async function addItem(evt) {
    try {
      const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: evt.dataset.addproduct,
          quantity: 1,
        }),
      });
      
      if (!result.ok) {
        throw new Error('Failed to add item to cart');
      }
      
      return await result.json();
    } catch (error) {
      console.error('Error adding item to cart:', error);
      throw error;
    }
  }

  // Use event delegation for quick add buttons to handle dynamically loaded products
  // and integrate loading animation
  document.addEventListener("click", async (event) => {
    const addButton = event.target.closest("[data-addproduct]");
    if (addButton) {
      try {
        addLoadingState(addButton);
        await addItem(addButton);

        if (window.theme.settings.cartPageLinkEnabled) {
          window.location.assign(window.theme.routes.cart);
        } else if (window.cart) {
          window.cart.openRebuySmartCart();
        }
      } catch (error) {
        // Handle error if needed
      } finally {
        removeLoadingState(addButton);
      }
    }
  });



})();

// ^^ Keep your scripts inside this IIFE function call to
// avoid leaking your variables into the global scope.
